var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { t } from "@/mixins/i18nMixin";
import { STORE } from "@/store";
import { SERVICE } from "@agentx/agentx-services";
import { action, makeObservable, observable } from "mobx";
export class ScheduledCallbackStore {
    constructor() {
        this.scheduleCallbackModalData = null;
        this.scheduleCallbackFormData = null;
        this.isScheduleCallbackModalOpen = false;
        this.personalCallbackCount = 0;
        this.personalCallbackSortOrder = "asc";
        this.personalCallbackSortBy = "scheduledTime";
        this.updatedCallbackDetail = null;
        this.updateIsScheduleCallbackModalOpen = (isShow) => {
            this.isScheduleCallbackModalOpen = isShow;
        };
        this.deleteScheduleCallbackData = () => {
            this.scheduleCallbackModalData = null;
            this.scheduleCallbackFormData = null;
            this.isScheduleCallbackModalOpen = false;
        };
        this.updateScheduleCallbackModalData = (updatedVal) => {
            if (updatedVal) {
                this.scheduleCallbackModalData = Object.assign(Object.assign({}, this.scheduleCallbackModalData), updatedVal);
            }
        };
        this.updateScheduleCallbackFormData = (updatedVal) => {
            if (updatedVal) {
                this.scheduleCallbackFormData = Object.assign(Object.assign({}, this.scheduleCallbackFormData), updatedVal);
            }
        };
        this.updatePersonalCallbackCount = (count) => {
            this.personalCallbackCount = count;
        };
        this.updatePersonalCallbackSortOrder = (sortOrder) => {
            this.personalCallbackSortOrder = sortOrder;
        };
        this.updatePersonalCallbackSortBy = (sortBy) => {
            this.personalCallbackSortBy = sortBy;
        };
        this.updateUpdatedCallbackDetail = (updated) => {
            this.updatedCallbackDetail = updated;
        };
        this.showWarningForMultipleDialogs = () => {
            STORE.session.errorModal.setErrorDetails({
                detail: {
                    modalType: "dialog",
                    header: t("app:callback.formValidation.existingModalWarningHeader"),
                    message: t("app:callback.formValidation.existingModalWarningMessage"),
                    buttons: [
                        {
                            type: "button",
                            label: t("app:callback.formValidation.closeSchedulerText"),
                            variant: "secondary",
                            onClick: () => {
                                STORE.session.errorModal.updateModalStatus(false);
                                STORE.scheduledCallback.deleteScheduleCallbackData();
                            }
                        },
                        {
                            type: "button",
                            label: t("app:callback.formValidation.keepEditingText"),
                            variant: "primary",
                            onClick: () => {
                                STORE.session.errorModal.updateModalStatus(false);
                                // Do not close the modal, just keep editing
                            }
                        }
                    ]
                }
            });
            STORE.session.errorModal.updateModalStatus(true);
        };
        this.showEntryPointNotConfiguredError = (trackingId, message) => {
            STORE.session.errorModal.setErrorDetails({
                detail: {
                    modalType: "dialog",
                    header: t("app:callback.cannotScheduleCall"),
                    message,
                    buttons: [
                        {
                            type: "button",
                            label: t("app:common.okButton"),
                            variant: "primary",
                            onClick: () => {
                                STORE.session.errorModal.updateModalStatus(false);
                            }
                        }
                    ],
                    trackingId
                }
            });
            STORE.session.errorModal.updateModalStatus(true);
        };
        makeObservable(this);
    }
    updateScheduleCallBackModalOnTrigger(payload) {
        const orgId = STORE.agent.organizationId;
        if (this.isScheduleCallbackModalOpen && payload.isShow) {
            this.showWarningForMultipleDialogs();
        }
        else {
            SERVICE.cms
                .fetchEntryPointForCallback({ orgId })
                .then((result) => {
                if ((result === null || result === void 0 ? void 0 : result.data) && result.data.length > 0) {
                    this.updateIsScheduleCallbackModalOpen(payload.isShow);
                    this.updateScheduleCallbackModalData(payload.callbackModalData);
                    this.updateScheduleCallbackFormData(payload.callbackFormData);
                }
                else {
                    this.showEntryPointNotConfiguredError("", t("app:callback.cannotScheduleCallMessage"));
                }
            })
                .catch((error) => {
                var _a;
                const err = Object.assign({}, error);
                this.showEntryPointNotConfiguredError((_a = err.details) === null || _a === void 0 ? void 0 : _a.trackingId, t("app:callback.error.genericErrorMessage"));
            });
        }
    }
}
__decorate([
    observable
], ScheduledCallbackStore.prototype, "scheduleCallbackModalData", void 0);
__decorate([
    observable
], ScheduledCallbackStore.prototype, "scheduleCallbackFormData", void 0);
__decorate([
    observable
], ScheduledCallbackStore.prototype, "isScheduleCallbackModalOpen", void 0);
__decorate([
    observable
], ScheduledCallbackStore.prototype, "personalCallbackCount", void 0);
__decorate([
    observable
], ScheduledCallbackStore.prototype, "personalCallbackSortOrder", void 0);
__decorate([
    observable
], ScheduledCallbackStore.prototype, "personalCallbackSortBy", void 0);
__decorate([
    observable
], ScheduledCallbackStore.prototype, "updatedCallbackDetail", void 0);
__decorate([
    action
], ScheduledCallbackStore.prototype, "updateScheduleCallBackModalOnTrigger", null);
__decorate([
    action
], ScheduledCallbackStore.prototype, "updateIsScheduleCallbackModalOpen", void 0);
__decorate([
    action
], ScheduledCallbackStore.prototype, "deleteScheduleCallbackData", void 0);
__decorate([
    action
], ScheduledCallbackStore.prototype, "updateScheduleCallbackModalData", void 0);
__decorate([
    action
], ScheduledCallbackStore.prototype, "updateScheduleCallbackFormData", void 0);
__decorate([
    action
], ScheduledCallbackStore.prototype, "updatePersonalCallbackCount", void 0);
__decorate([
    action
], ScheduledCallbackStore.prototype, "updatePersonalCallbackSortOrder", void 0);
__decorate([
    action
], ScheduledCallbackStore.prototype, "updatePersonalCallbackSortBy", void 0);
__decorate([
    action
], ScheduledCallbackStore.prototype, "updateUpdatedCallbackDetail", void 0);
export const scheduledCallback = new ScheduledCallbackStore();
